<template>
  <initio-panel @submit-handler="submitHandler" :errors="errors">
    <template v-slot:title>
      Create your account
    </template>
    <template v-slot:before_form>
      <div v-if="!client.cli_num" class="notification is-info-blue">
        <strong>Already have an account?</strong> <a href="/app/login?redirect=/spa/vehicle/new">Login, then add this policy</a>
      </div>
    </template>

    <template v-slot:sidebar>
      <initio-summary class="info-box" />
    </template>
  </initio-panel>
</template>

<script>

import InitioPanel from '@/components/initio/InitioPanel.vue'
import InitioSummary from '@/components/partials/Summary.vue'
import stepSubmit from '@/mixins/stepSubmit.js'
import { mapGetters } from 'vuex'

export default {
  components: {
    InitioPanel,
    InitioSummary
  },
  mixins: [
    stepSubmit
  ],
  computed: {
    ...mapGetters({
      answers: 'flattenedAnswers',
      client: 'client'
    }),
  },

  beforeMount (){

    // Determine if CreateAccount details are eligible to be pre-filled.
    const is_new_client = ! this.client.cli_num;
    const user_is_main_driver = this.answers['Vehicle.DriverDetails'].driver_details_is_main_driver === 'yes';
    const is_new_driver = this.answers['Vehicle.Confirm'].vehicle_confirm_driver === 'new-driver';

    // Only pre-fill if new client, user is main driver, hasn't started filling out createAccount at all yet
    if( is_new_client && user_is_main_driver && is_new_driver  ){
      const account_answers = this.answers['Vehicle.CreateAccount'];

      if( !account_answers.create_account_dob &&
          !account_answers.create_account_first_name &&
          !account_answers.create_account_last_name &&
          !account_answers.create_account_address ){

        // Preload answers
        this.$store.commit('setAnswer',{
          step: 'Vehicle.CreateAccount',
          answer: 'create_account_dob',
          value: this.answers['Vehicle.Confirm'].vehicle_confirm_driver_dob
        });

        // Because client name is nested, we need to add it nested
        this.$store.commit('setAnswer',{
          step: 'Vehicle.CreateAccount',
          answer: 'create_account_name',
          value: {
                  create_account_first_name: this.answers['Vehicle.DriverDetails'].driver_details_first_name,
                  create_account_last_name: this.answers['Vehicle.DriverDetails'].driver_details_last_name,
                }
          });
        
        // Use the primary address from locatio autocomplete or fallback to the unknown address
        const full_address_auto_complete = this.answers['Vehicle.Confirm'].vehicle_confirm_park_address_full_address
        const selected_address = full_address_auto_complete ? full_address_auto_complete : this.answers['Vehicle.Confirm'].vehicle_confirm_park_address_displayed_address;
        this.$store.commit('setAnswer',{
          step: 'Vehicle.CreateAccount',
          answer: 'create_account_address',
          value: selected_address,
        });

      }
    }
  },
  mounted () {

    this.$store.dispatch('getSchema', 'new/create-account' )
        .then(response => {
          this.$store.commit('updateSchema', response);
        })
  },
  methods: {
    submitHandler() {
      let context = this;

      this.genericSubmitHandler()
          .then(response => {
            // console.log(response)
          }, error => {
            console.error("VehicleAccountDetails Handler error", error); // Unsure if we need this or not, remove if not needed
            context.errors = error;
          });
    }
  },
  data () {
    return {
      errors: [],
      schema: []
    }
  }
}

</script>

<style scoped lang="scss">

</style>